/*
  Sound (mute/unmute) button for hero videos rendered by snippets/video.liquid
  with `show_sound_button: true` (currently sections/video-with-text-overlay.liquid).

  Videos always start muted — browsers only allow autoplay when muted — so the
  button lets a visitor opt in to the audio. One delegated listener handles every
  button on the page; the guard below keeps a second copy of this script inert.
*/
(function () {
  if (window.__videoSoundToggleBound) return;
  window.__videoSoundToggleBound = true;

  function sync(button, video) {
    var muted = video.muted;
    button.setAttribute('aria-pressed', muted ? 'false' : 'true');
    button.setAttribute('aria-label', muted ? button.dataset.labelUnmute : button.dataset.labelMute);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.sound-button');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    var media = button.closest('video-media');
    if (!media) return;

    var video = media.querySelector('video');
    if (video) {
      if (video.muted) {
        video.muted = false;
        video.volume = 1;
        if (video.paused) media.play();
      } else {
        video.muted = true;
      }
      sync(button, video);
      return;
    }

    // Autoplay is off and the <video> is still inside its <template>: start it,
    // then unmute as soon as the theme swaps the real element in.
    media.addEventListener('video:play', function once() {
      media.removeEventListener('video:play', once);
      var loaded = media.querySelector('video');
      if (loaded) {
        loaded.muted = false;
        loaded.volume = 1;
        sync(button, loaded);
      }
    });
    media.play();
  });

  // Keep the icon honest if anything else flips the mute state.
  document.addEventListener('volumechange', function (event) {
    var video = event.target;
    if (!(video instanceof HTMLVideoElement)) return;
    var media = video.closest('video-media');
    var button = media && media.querySelector('.sound-button');
    if (button) sync(button, video);
  }, true);
})();
